
import { format, isValid, parse, addMonths } from "date-fns";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface DateRangeFieldsProps {
  startDate: Date;
  endDate: Date;
  onStartDateChange: (date?: Date) => void;
  onEndDateChange: (date?: Date) => void;
}

export const DateRangeFields = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
}: DateRangeFieldsProps) => {
  const formatDateForInput = (date: Date) => {
    if (!isValid(date)) {
      return '';
    }
    return format(date, 'yyyy-MM-dd');
  };

  const handleDateChange = (dateString: string, onChange: (date?: Date) => void, isStartDate: boolean = false) => {
    if (!dateString) {
      onChange(undefined);
      return;
    }

    // Handle direct date input
    if (dateString.includes('-')) {
      const parsedDate = parse(dateString, 'yyyy-MM-dd', new Date());
      if (isValid(parsedDate)) {
        onChange(parsedDate);
        // If this is the start date changing, update the end date to 6 months later
        if (isStartDate) {
          onEndDateChange(addMonths(parsedDate, 6));
        }
      }
    } else {
      // Handle manual input in different formats
      const cleanDate = dateString.replace(/[^\d]/g, '');
      if (cleanDate.length === 8) {
        const year = parseInt(cleanDate.substring(0, 4));
        const month = parseInt(cleanDate.substring(4, 6)) - 1;
        const day = parseInt(cleanDate.substring(6, 8));
        const parsedDate = new Date(year, month, day, 12, 0, 0);
        if (isValid(parsedDate)) {
          onChange(parsedDate);
          // If this is the start date changing, update the end date to 6 months later
          if (isStartDate) {
            onEndDateChange(addMonths(parsedDate, 6));
          }
        }
      }
    }
  };

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label>Start Date</Label>
        <Input
          type="date"
          value={startDate ? formatDateForInput(startDate) : ""}
          onChange={(e) => handleDateChange(e.target.value, onStartDateChange, true)}
          className="h-14"
          min="2000-01-01"
          max="2100-12-31"
        />
      </div>
      <div className="space-y-2">
        <Label>End Date</Label>
        <Input
          type="date"
          value={endDate ? formatDateForInput(endDate) : ""}
          onChange={(e) => handleDateChange(e.target.value, onEndDateChange)}
          className="h-14"
          min="2000-01-01"
          max="2100-12-31"
        />
      </div>
    </div>
  );
};
